import { IconButton } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { TrashIcon } from "src/documentUpload/TrashIcon";
import { EditIcon } from "src/entityView/EditIcon";
import { getUserId } from "src/login/selector";
import { State } from "src/state";
import "./CommentCard.scss";
import { isCommentUnread } from "./helpers";
import { Comment } from "./types";

interface CommentCardProps {
  comment: Comment;
  dontShowAccountLabel?: boolean;
  editComment?: (comment: Comment) => void;
  canEditComments?: boolean;
  deleteComment?: (comment: Comment) => void;
  canDeleteComments?: boolean;
  userId: string;
}

export class CommentCard extends React.Component<CommentCardProps> {
  public render() {
    const {
      userId,
      dontShowAccountLabel,
      comment,
      canEditComments,
      editComment,
      deleteComment,
      canDeleteComments
    } = this.props;
    const handleEditIconClick = () => {
      if (editComment) {
        editComment(comment);
      }
    };

    const handleDeleteIconClick = () => {
      if (deleteComment) {
        deleteComment(comment);
      }
    };

    const period = comment.period;

    return (
      <div className="CommentCard">
        <div className="CommentCard__header">
          <div className="CommentCard__username">
            <div
              className={classnames(
                "CommentCard__read-status",
                {
                  "CommentCard__read-status--unread": isCommentUnread(
                    comment,
                    userId
                  )
                },
                {
                  "CommentCard__read-status--read": !isCommentUnread(
                    comment,
                    userId
                  )
                }
              )}
            />
            {comment.username}
          </div>

          <div className="CommentCard__timestamp">{comment.commentTime}</div>
        </div>
        {comment.accountName && !dontShowAccountLabel && (
          <div className="CommentCard__statement-label">
            {comment.financialStatementType}
          </div>
        )}

        {period && (
          <div className="CommentCard__period">{`${period} Spread`}</div>
        )}

        {comment.accountName && !dontShowAccountLabel && (
          <React.Fragment>
            <div className="CommentCard__account-label">Account</div>
            <div className="CommentCard__account-name">
              {comment.accountName}
            </div>
          </React.Fragment>
        )}
        <div className="CommentCard__body-container">
          <div className="CommentCard__body">{comment.body}</div>
          <div className="CommentCard__actions">
            {canEditComments && (
              <IconButton
                className="CommentCard__edit"
                onClick={handleEditIconClick}
              >
                <EditIcon />
              </IconButton>
            )}
            {canDeleteComments && (
              <IconButton
                className="CommentCard__delete"
                onClick={handleDeleteIconClick}
              >
                <TrashIcon />
              </IconButton>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  userId: getUserId(state)
});

export default connect(mapStateToProps)(CommentCard);



// WEBPACK FOOTER //
// ./src/commentView/CommentCard.tsx